import { useMemo } from 'react';

interface UseBookingTimerParams {
  /** Дата окончания времени на оплату (после создания заказа) */
  validDateTime: string | null;
  /** Флаг процесса отправки формы */
  isSubmitting: boolean;
}

interface UseBookingTimerReturn {
  /** Флаг необходимости отображения таймера */
  shouldShowTimer: boolean;
  /** Время окончания (ISO string) */
  duration: string;
  /** Текст подписи таймера */
  label: string;
}

/** Hook для определения параметров таймера оплаты */
export const useBookingTimer = ({
  validDateTime,
  isSubmitting,
}: UseBookingTimerParams): UseBookingTimerReturn => {
  return useMemo(() => {
    const shouldShowTimer = !!validDateTime && !isSubmitting;

    return {
      shouldShowTimer,
      duration: validDateTime || '',
      label: 'Время для оплаты',
    };
  }, [validDateTime, isSubmitting]);
};
